module.exports = __webpack_public_path__ + "static/media/PrebookCenterConfirm.c2f5bce4.svg";